import React from 'react';
import styled from 'styled-components';
import { useAuthStore } from '../store/authStore';
import { StudentDashboard } from '../pages/dashboard/StudentDashboard';
import { SuperAdminDashboard } from '../pages/dashboard/SuperAdminDashboard';
import { AdminDashboard } from '../pages/dashboard/AdminDashboard';
import { ModeratorDashboard } from '../pages/dashboard/ModeratorDashboard';
import { AnalystDashboard } from '../pages/dashboard/AnalystDashboard';
import { ContentManagerDashboard } from '../pages/dashboard/ContentManagerDashboard';
import { TeacherDashboard } from '../pages/dashboard/TeacherDashboard';

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  flex-direction: column;
  gap: 1rem;
`;

const RoleBasedDashboard: React.FC = () => {
  const { user, isAuthenticated } = useAuthStore();

  if (!isAuthenticated || !user) {
    return (
      <ErrorContainer>
        <div>请先登录</div>
      </ErrorContainer>
    );
  }

  // Determine which dashboard to show based on user's primary role
  const primaryRole = user.primaryRole || 'student';
  const roles = user.roles || [];

  // If user has no roles, show student dashboard
  if (!roles || roles.length === 0) {
    return <StudentDashboard />;
  }

  // Route to appropriate dashboard based on primary role
  switch (primaryRole) {
    case 'super_admin':
      return <SuperAdminDashboard />;
    case 'admin':
      return <AdminDashboard />;
    case 'moderator':
      return <ModeratorDashboard />;
    case 'analyst':
      return <AnalystDashboard />;
    case 'content_manager':
      return <ContentManagerDashboard />;
    case 'teacher':
      return <TeacherDashboard />;
    case 'student':
    default:
      return <StudentDashboard />;
  }
};

export default RoleBasedDashboard;
